module.exports = __webpack_public_path__ + "img/icon-download.2ba68e70.svg";